export default {
  indexUserGroups: [],
  assetUserGroups: [],
  userGroupEntityAssignmentInput: null,
};
